'use client'

import Link from 'next/link'
import Image from 'next/image'
import { Phone, Mail, MapPin, Clock, Home, FileText, DollarSign } from 'lucide-react'

export function Footer() {
  // Define which links are active
  const inactiveClass = "text-gray-400 cursor-not-allowed pointer-events-none"
  const activeClass = "text-gray-300 hover:text-[#c88546] transition-colors"

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info & Location */}
          <div>
            <Image
              src="/images/logo.png"
              alt="Southwest Homes"
              width={200}
              height={50}
              className="mb-4 brightness-0 invert"
            />
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-[#c88546] mt-1" />
                <div className="text-gray-300 text-sm">
                  <p>8841 Florentine Rd Suite C</p>
                  <p>Prescott Valley, AZ 86314</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Clock className="w-4 h-4 text-[#c88546]" />
                <span className="text-gray-300 text-sm">By Appointment Only</span>
              </div>
            </div>
          </div>

          {/* Home Solutions */}
          <div>
            <h3 className="font-bold mb-4 flex items-center gap-2">
              <Home className="w-4 h-4 text-[#c88546]" />
              Home Solutions
            </h3>
            <ul className="space-y-2">
              <li>
                <Link href="/floor-plans" className={activeClass}>
                  Browse Floor Plans
                </Link>
              </li>
              <li>
                <Link href="/manufactured-homes" className={activeClass}>
                  Service Areas
                </Link>
              </li>
              <li>
                <span className={inactiveClass}>
                  Land & Site Services
                </span>
              </li>
              <li>
                <Link href="/process" className={activeClass}>
                  Our Process
                </Link>
              </li>
              <li>
                <button 
                  onClick={() => window.dispatchEvent(new CustomEvent('showQuoteModal'))}
                  className={activeClass + " text-left"}
                >
                  Free Buyer's Guide
                </button>
              </li>
            </ul>
          </div>

          {/* Resources & Financing */}
          <div>
            <h3 className="font-bold mb-4 flex items-center gap-2">
              <DollarSign className="w-4 h-4 text-[#c88546]" />
              Resources
            </h3>
            <ul className="space-y-2">
              <li>
                <Link href="/financing" className={activeClass}>
                  Financing Options
                </Link>
              </li>
              <li>
                <Link href="/financing/fha-manufactured-home-loans" className={activeClass}>
                  FHA Loans
                </Link>
              </li>
              <li>
                <Link href="/financing/va-manufactured-home-loans" className={activeClass}>
                  VA Loans
                </Link>
              </li>
              <li>
                <Link href="/about" className={activeClass}>
                  About Us
                </Link>
              </li>
              <li>
                <Link href="/get-started" className={activeClass}>
                  Get Started
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact R.J. */}
          <div>
            <h3 className="font-bold mb-4">Contact R.J. Today</h3>
            <div className="space-y-3 mb-4">
              <a 
                href="tel:9283610298" 
                className="flex items-center gap-2 text-gray-300 hover:text-[#c88546] transition-colors"
              >
                <Phone className="w-4 h-4 text-[#c88546]" />
                <span>(928) 361-0298</span>
              </a>
              <a 
                href="mailto:rj@southwesthomesaz.com" 
                className="flex items-center gap-2 text-gray-300 hover:text-[#c88546] transition-colors"
              >
                <Mail className="w-4 h-4 text-[#c88546]" />
                <span>rj@southwesthomesaz.com</span>
              </a>
            </div>
            <Link 
              href="/get-started"
              className="inline-flex items-center justify-center bg-[#c88546] hover:bg-[#b87439] text-white px-4 py-2 rounded-lg transition-colors text-sm font-medium"
            >
              Get Free Consultation
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-300 text-sm">
              © {new Date().getFullYear()} Fast Affordable Homes. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link 
                href="/privacy-policy" 
                className="text-gray-300 hover:text-[#c88546] transition-colors text-sm"
              >
                Privacy Policy
              </Link>
              <Link 
                href="/terms-of-service" 
                className="text-gray-300 hover:text-[#c88546] transition-colors text-sm"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}